import { MainWorkflowNode } from 'app/core/enums';
import { StepBarNode } from '../step-bar';

export const MAIN_WORKFLOW_NODE_CONFIGS: StepBarNode[] = [
  {
    key: MainWorkflowNode.Case,
    title: 'general.case',
    path: 'case',
  },
  {
    key: MainWorkflowNode.Files,
    title: 'general.files',
    path: 'files',
  },
  {
    key: MainWorkflowNode.Order,
    title: 'general.order',
    path: 'order',
  },
  {
    key: MainWorkflowNode.Reprint,
    title: 'general.reprint',
    path: 'reprint',
  }
];
